import React from 'react';
import s from './index.module.css';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { dialogsActions, expertsActions, metaActions } from '../../store/actions';
import {
    getDialogsItems,
    getIsArchiveDialogFixed,
    getIsBigTabletAndDesktop,
    getIsMobile,
    getIsNewExpertButtonDisabled
} from '../../store/selectors';

import Button from '../Button';
import ConsultationsBlock from './ConsultationsBlock';

const ExpertChatHistory = () => {
    const dispatch = useDispatch();
    const isMobile = useSelector(getIsMobile);
    const isBigTabletAndDesktop = useSelector(getIsBigTabletAndDesktop);
    const isNewExpertButtonDisabled = useSelector(getIsNewExpertButtonDisabled);
    const isArchiveDialogFixed = useSelector(getIsArchiveDialogFixed);
    const dialogs = useSelector(getDialogsItems);

    // архивный диалог
    const archiveDialog = dialogs?.filter(item => item.dialog_type_id === 0);
    // неархивные диалоги
    // при Передаче другому эксперту постоянного клиента, у клиента не должен пропадать диалог
    const directDialogs = dialogs.filter(item => item.dialog_type_id === 1);
    const activeDialogs = directDialogs.filter(item =>
        (!!item.expert_id && item.status_id === 1) ||
        (!item.expert_id && item.is_regular_customer && item.status_id === 0));
    const historyDialogs = directDialogs.filter(item => !!item.expert_id && item.status_id !== 1);

    const isRenderActiveDialogs = activeDialogs.length > 0;

    const handleGetNewExpert = () => {
        dispatch(metaActions.setCurrentMobileLayout('chat'));
        dispatch(expertsActions.setCallNewExpertButtonDisabled(true));
        dispatch(dialogsActions.setIsArchiveCurrentDialog(false));
        dispatch(dialogsActions.findNewExpert());
    };

    const changeExpertButton = (
        <Button
            className={s.changeExpertButton}
            view="button"
            size="big"
            background="white"
            disabled={isNewExpertButtonDisabled}
            onClick={handleGetNewExpert}
        >Позвать другого эксперта</Button>
    );

    const isDialogsWrapperWithPadding = isArchiveDialogFixed && historyDialogs.length > 0;

    return (
        <React.Fragment>
            {isMobile &&
                <div className={s.callExpertButtonWrapper}>
                    {changeExpertButton}
                </div>
            }
            <div className={s.dialogsScrollBlock}>
                {isBigTabletAndDesktop && changeExpertButton}
                <div className={s.consultationsBlock}>
                    {isRenderActiveDialogs &&
                        <ConsultationsBlock
                            isCurrentConsultations={true}
                            dialogsList={activeDialogs} />
                    }
                    <div className={cx(s.historyDialogsWrapper,
                        { [s.wrapperWithPadding]: isDialogsWrapperWithPadding })}
                    >
                        <ConsultationsBlock
                            isCurrentConsultations={false}
                            dialogsList={historyDialogs} />
                    </div>
                    {historyDialogs.length === 0 &&
                        <div className={s.dialogsDisclamerText}>Здесь будут сохраняться ваши переписки с экспертами</div>
                    }
                    {archiveDialog.length > 0 &&
                        <ConsultationsBlock
                            isArchiveDialog={true}
                            dialogsList={archiveDialog}
                        />
                    }
                </div>
            </div>
        </React.Fragment>
    );
};

export default ExpertChatHistory;
